import axios from 'axios';
import { removeToken,getLocalStorageToken,removeLocalStorageToken } from '@/utils/auth'
import { removeUsername,removeLocalStorageUsername } from '@/utils/auth'
import { removeNickname,removeLocalStorageNickname } from '@/utils/auth'
import { removeAvatar,removeLocalStorageAvatar } from '@/utils/auth'
import { removeRoles,removeLocalStorageRoles } from '@/utils/auth'
// import store from '@/store'
import {Message} from 'element-ui'
// // import errorCode from '@/utils/errorCode'

//携带证书
axios.defaults.withCredentials = true;
//设置超时时间
axios.defaults.timeout = 100000;

axios.defaults.headers['Content-Type'] = 'application/json;charset=utf-8'

// request拦截器
axios.interceptors.request.use(config => {
    // 是否需要设置 token
    const isToken = (config.headers || {}).isToken === false
    if (getLocalStorageToken() && !isToken) {
        // console.log("getToken,Test")
        // console.log(getToken())
        // 让每个请求携带自定义token 请根据实际情况自行修改
        config.headers['token'] = getLocalStorageToken()
        // config.headers['Authorization'] = 'Bearer ' + getToken() // 让每个请求携带自定义token 请根据实际情况自行修改
    }
    return config
}, error => {
    // console.log(error)
    Promise.reject(error)
})

// http response 拦截器
axios.interceptors.response.use(
    response => {
        // if (response.data.code===20001) {
        //     Message({
        //         message: response.data.msg,
        //         type: 'error'
        //     })
        //     // console.log(response.data.msg)
        // }
        if (response.data.code===20002) {
            Message({
                message: response.data.msg,
                type: 'error'
            })
            removeToken()
            removeUsername()
            removeNickname()
            removeAvatar()
            removeRoles()

            removeLocalStorageToken()
            removeLocalStorageUsername()
            removeLocalStorageNickname()
            removeLocalStorageAvatar()
            removeLocalStorageRoles()

            location.reload()
            // console.log(response.data.msg)
        }
        return response;
    },
    error => {
        if (error.response) {
            switch (error.response.status) {
                case 500:
                    this.$store.commit('del_token');
                    console.log("5000")
                    // router.replace({
                    //     path: '/login',
                    //     query: {redirect: router.currentRoute.fullPath}//登录成功后跳入浏览的当前页面
                    // })
            }
        }
        return Promise.reject(error.response.data)
    });

// // 响应拦截器
// axios.interceptors.response.use(res => {
//         // 未设置状态码则默认成功状态
//         const code = res.data.code;
//         // const code = res.data.code || 20000;
//         // 获取错误信息
//         // const msg = errorCode[code] || res.data.msg || errorCode['default']
//         if (code === 500) {
//             MessageBox.confirm('登录状态已过期，您可以继续留在该页面，或者重新登录', '系统提示', {
//                     confirmButtonText: '重新登录',
//                     cancelButtonText: '取消',
//                     type: 'warning'
//                 }
//             ).then(() => {
//                 store.dispatch('LogOut').then(() => {
//                     location.href = '/login';
//                 })
//             })
//         }
//         // else {
//         //     console.log("=="+res.data.code)
//         //     return res.data
//         // }
//     },
// )

export default {

    //get请求
    requestGet(url, params = {}) {
        return new Promise((resolve, reject) => {
            axios.get(url, params).then(res => {
                resolve(res.data)
            }).catch(error => {
                reject(error)
            })
        })
    },

    // post请求
    requestPost(url, params = {}) {
        return new Promise((resolve, reject) => {
            axios.post(url, params).then(res => {
                resolve(res.data)
            }).catch(error => {
                reject(error)
            })
        })
    },
    // delete请求
    requestDelete(url, params = {}) {
        return new Promise((resolve, reject) => {
            axios.delete(url, params).then(res => {
                resolve(res.data)
            }).catch(error => {
                reject(error)
            })
        })
    },
    // put请求
    requestPut(url, params = {}) {
        return new Promise((resolve, reject) => {
            axios.put(url, params).then(res => {
                resolve(res.data)
            }).catch(error => {
                reject(error)
            })
        })
    }
}
